import React, { useEffect } from 'react'
import { navigate, graphql, useStaticQuery } from 'gatsby'
import { usePrismicPreview } from 'gatsby-source-prismic'

const q = graphql`
  {
    sitePlugin(name: { eq: "@kogk/gatsby-theme-prismic" }) {
      pluginOptions {
        repositoryName
      }
    }

    allPrismicPreviewableUids {
      nodes {
        uid
      }
    }
  }
`

export default ({ linkResolver }) => {
  // todo: make a component or hook out of this for inclusion in the preview file
  if (typeof window === 'undefined') {
    return null
  }

  const results = useStaticQuery(q)
  const {
    sitePlugin: {
      pluginOptions: { repositoryName }
    },
    allPrismicPreviewableUids: { nodes: previewableNodes }
  } = results

  const allUids = previewableNodes.map(node => node.uid)

  const pathResolver = () => doc => {
    const previewedUid = doc.uid

    return allUids.includes(previewedUid) ? linkResolver(doc) : '/draft'
  }

  const { previewData, path } = usePrismicPreview({
    repositoryName,
    pathResolver
  })

  useEffect(() => {
    if (previewData && path) {
      window.__PRISMIC_PREVIEW_DATA__ = previewData
      navigate(path)
    }
  }, [previewData, path])

  return (
    <div
      style={{
        display: 'flex'
      }}
    >
      <div
        style={{
          color: '#4b3f9f',
          fontWeight: 'bold',
          fontSize: '30px'
        }}
      >
        Andartak...
      </div>
    </div>
  )
}
